import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { PageWrapper } from "src/general/layout/Page/PageWrapper";

interface HttpErrorProps {
  statusCode: number;
  message: string;
  description?: string;
}

/** Component for displaying page-level HTTP error message (403/404/etc.) */
export const HttpError = ({
  statusCode,
  message,
  description,
}: HttpErrorProps) => {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <h1 data-testid="http-error" className="text-6xl font-bold text-warning">
        {statusCode}
      </h1>
      <p className="text-xl">{message}</p>
      {description && <p className="text-muted">{description}</p>}
      <Link to="/" className="text-accent hover:text-accent">
        {t("error::Back to Home")}
      </Link>
    </PageWrapper>
  );
};
